<script setup>
import {defineProps} from 'vue'
const props = defineProps({
  "data": { Type: Array, Default: [] },
  "maxlen": { Type: Number, Default: 3 },
  "nostyle": { Type: Boolean, Default: false },
  "field": { type: String, default: '' },
  "getPillState": { type: Function, default: () => () => 0 }
})

function pillClass(value) {
  const state = props.getPillState(props.field, value)
  if (state === 1) return 'pill-selected-field'
  if (state === 2) return 'pill-selected-value'
  return ''
}

let shown_tags = [];
let hidden_tags = [];

if (props.maxlen != undefined && props.maxlen != null && props.data != null && props.data.length > 0) {
  for (let i=0; i < props.data.length; i++) {
    if (i < props.maxlen) {
      shown_tags.push(props.data[i]) 
    } else {
      hidden_tags.push(props.data[i])
    }
  }
} 

</script>
<template>
  <div>
    <div v-if="props.data != null && props.data.length > 0"  >

      <div v-if="props.maxlen == undefined || props.maxlen == null || props.data.length <= props.maxlen" class="d-flex vertically-centered">
        <div v-for="tag in props.data">
          <div :class="[{'tag': !nostyle, 'nsm': nostyle}, pillClass(tag)]" v-if="tag != ''" :data-shift-field="props.field" :data-shift-value="tag">
            <span >{{tag}}</span>
          </div>
        </div>
      </div>
      <div v-else style="position: relative;" class="d-flex vertically-centered" >
        <div v-for="tag in shown_tags">
          <div :class="[{'tag': !nostyle, 'nsm': nostyle}, pillClass(tag)]" v-if="tag != ''" :data-shift-field="props.field" :data-shift-value="tag">
            <span >{{tag}}</span>
          </div>
        </div>
        <span class="tag dropdown dropdown-toggle" data-bs-toggle="dropdown" ><span>+ {{hidden_tags.length}}</span></span>
        <ul class="dropdown-menu scrollable">
          <li v-for="st in hidden_tags" :class="pillClass(st)" :data-shift-field="props.field" :data-shift-value="st">{{st}}</li>
        </ul>
      </div>

    </div>
  </div>
</template>

<style scoped>
.dropdown-menu li {
  color:white  !important;;
  padding: 0 .5rem;
} 
.dropdown-menu {
  background-color: var(--surface-card) !important;
}

.tag {
  position: relative;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-xl);
  font-size: .9rem;
  padding: 0 .5rem;
  margin-right: .1rem;
}

.nsm {
  margin-right: .5rem;
}


.scrollable {
  max-height: 100px;
  overflow-y: auto;
}

.tag.pill-selected-field,
.nsm.pill-selected-field,
.dropdown-menu li.pill-selected-field {
  background-color: var(--accent-soft-4);
  border-color: var(--accent);
  color: var(--text-primary);
  border-radius: var(--radius-sm);
}

.tag.pill-selected-value,
.nsm.pill-selected-value,
.dropdown-menu li.pill-selected-value {
  background-color: rgba(245, 158, 11, 0.22);
  border-color: var(--color-warning);
  color: var(--color-warning-text);
  border-radius: var(--radius-sm);
}

.nsm.pill-selected-field,
.nsm.pill-selected-value {
  padding: 0 .4rem;
}
</style>
